module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_10.9b99ab34.svg";